(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("shifty", [], factory);
	else if(typeof exports === 'object')
		exports["shifty"] = factory();
	else
		root["shifty"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tweenable = exports.composeEasingObject = exports.tweenProps = exports.clone = exports.each = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.tween = tween;

var _easingFunctions = __webpack_require__(5);

var easingFunctions = _interopRequireWildcard(_easingFunctions);

var _objectAssign = __webpack_require__(1);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _token = __webpack_require__(7);

var token = _interopRequireWildcard(_token);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS
var DEFAULT_EASING = 'linear';
var DEFAULT_DURATION = 500;
var UPDATE_TIME = 1000 / 60;
var root = typeof window !== 'undefined' ? window : global;

var cancelTimer = root.cancelAnimationFrame || root.webkitCancelAnimationFrame || root.oCancelAnimationFrame || root.msCancelAnimationFrame || root.mozCancelRequestAnimationFrame || root.clearTimeout;

// requestAnimationFrame() shim by Paul Irish (modified for Shifty)
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var DEFAULT_SCHEDULE_FUNCTION = root.requestAnimationFrame || root.webkitRequestAnimationFrame || root.oRequestAnimationFrame || root.msRequestAnimationFrame || root.mozCancelRequestAnimationFrame && root.mozRequestAnimationFrame || setTimeout;

var noop = function noop() {};

/**
 * Handy shortcut for doing a for-in loop. This is not a "normal" each
 * function, it is optimized for Shifty.  The iterator function only receives
 * the property name, not the value.
 * @param {Object} obj
 * @param {Function(string)} fn
 * @private
 */
var each = exports.each = function each(obj, fn) {
  return Object.keys(obj).forEach(fn);
};

/**
 * @param {Object} obj
 * @return {Object}
 * @private
 */
var clone = exports.clone = function clone(obj) {
  return (0, _objectAssign2.default)({}, obj);
};

var formulas = clone(easingFunctions);

/**
 * Tweens a single property.
 * @param {number} start The value that the tween started from.
 * @param {number} end The value that the tween should end at.
 * @param {Function} easingFunc The easing curve to apply to the tween.
 * @param {number} position The normalized position (between 0.0 and 1.0) to
 * calculate the midpoint of 'start' and 'end' against.
 * @return {number} The tweened value.
 * @private
 */
var tweenProp = function tweenProp(start, end, easingFunc, position) {
  return start + (end - start) * easingFunc(position);
};

/**
 * Calculates the interpolated tween values of an Object for a given
 * timestamp.
 * @param {Number} forPosition The position to compute the state for.
 * @param {Object} currentState Current state properties.
 * @param {Object} originalState: The original state properties the Object is
 * tweening from.
 * @param {Object} targetState: The destination state properties the Object
 * is tweening to.
 * @param {number} duration: The length of the tween in milliseconds.
 * @param {number} timestamp: The UNIX epoch time at which the tween began.
 * @param {Object.<string|function>} easing: This Object's keys must correspond
 * to the keys in targetState.
 * @private
 */
var tweenProps = exports.tweenProps = function tweenProps(forPosition, currentState, originalState, targetState, duration, timestamp, easing) {
  var normalizedPosition = forPosition < timestamp ? 0 : (forPosition - timestamp) / duration;

  each(currentState, function (key) {
    var easingObjectProp = easing[key];
    var easingFn = typeof easingObjectProp === 'function' ? easingObjectProp : formulas[easingObjectProp];

    currentState[key] = tweenProp(originalState[key], targetState[key], easingFn, normalizedPosition);
  });

  return currentState;
};

/**
 * Creates a usable easing Object from a string, a function or another easing
 * Object.  If `easing` is an Object, then this function clones it and fills
 * in the missing properties with `"linear"`.
 * @param {Object.<string|Function>} fromTweenParams
 * @param {Object|string|Function} easing
 * @return {Object.<string|Function>}
 * @private
 */
var composeEasingObject = exports.composeEasingObject = function composeEasingObject(fromTweenParams) {
  var easing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_EASING;

  var composedEasing = {};
  var typeofEasing = typeof easing === 'undefined' ? 'undefined' : _typeof(easing);

  if (typeofEasing === 'string' || typeofEasing === 'function') {
    each(fromTweenParams, function (prop) {
      return composedEasing[prop] = easing;
    });
  } else {
    each(fromTweenParams, function (prop) {
      return composedEasing[prop] = composedEasing[prop] || easing[prop] || DEFAULT_EASING;
    });
  }

  return composedEasing;
};

var Tweenable = exports.Tweenable = function () {
  /**
   * @param {Object} [initialState={}] The values that the initial tween should
   * start at if a `from` value is not provided to {@link
   * shifty.Tweenable#tween} or {@link shifty.Tweenable#setConfig}.
   * @param {shifty.tweenConfig} [config] Configuration object to be passed to
   * {@link shifty.Tweenable#setConfig}.
   * @constructs shifty.Tweenable
   */
  function Tweenable() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Tweenable);

    this._currentState = initialState;
    this._configured = false;
    this._scheduleFunction = DEFAULT_SCHEDULE_FUNCTION;

    // To prevent unnecessary calls to setConfig do not set default
    // configuration here.  Only set default configuration immediately before
    // tweening if none has been set.
    if (config !== undefined) {
      this.setConfig(config);
    }
  }

  /**
   * Applies a filter to Tweenable instance.
   * @param {shifty.Tweenable} tweenable The `Tweenable` instance to call the filter
   * upon.
   * @param {string} filterName The name of the filter to apply.
   * @private
   */


  _createClass(Tweenable, [{
    key: '_applyFilter',
    value: function _applyFilter(filterName) {
      var _this = this;

      var filters = Tweenable.filters;
      var args = this._filterArgs;

      each(filters, function (name) {
        var filter = filters[name][filterName];

        if (typeof filter !== 'undefined') {
          filter.apply(_this, args);
        }
      });
    }

    /**
     * Handles the update logic for one step of a tween.
     * @param {number} [currentTimeOverride] Needed for accurate timestamp in
     * shifty.Tweenable#seek.
     * @private
     */

  }, {
    key: '_timeoutHandler',
    value: function _timeoutHandler(currentTimeOverride) {
      var _this2 = this,
          _arguments = arguments;

      var _currentState = this._currentState,
          _delay = this._delay;
      var _duration = this._duration,
          _step = this._step,
          _targetState = this._targetState,
          _timestamp = this._timestamp;


      var endTime = _timestamp + _delay + _duration;
      var currentTime = Math.min(currentTimeOverride || Tweenable.now(), endTime);
      var hasEnded = currentTime >= endTime;
      var offset = _duration - (endTime - currentTime);

      if (this.isPlaying()) {
        if (hasEnded) {
          _step(_targetState, this._attachment, offset);
          this.stop(true);
        } else {
          // This function needs to be .call-ed because it is a native method in
          // some environments:
          // http://stackoverflow.com/a/9678166
          this._scheduleId = this._scheduleFunction.call(root, function () {
            return _this2._timeoutHandler.apply(_this2, _arguments);
          }, UPDATE_TIME);

          this._applyFilter('beforeTween');

          // If the animation has not yet reached the start point (e.g., there was
          // delay that has not yet completed), just interpolate the starting
          // position of the tween.
          if (currentTime < _timestamp + _delay) {
            currentTime = 1;
            _duration = 1;
            _timestamp = 1;
          } else {
            _timestamp += _delay;
          }

          tweenProps(currentTime, _currentState, this._originalState, _targetState, _duration, _timestamp, this._easing);

          this._applyFilter('afterTween');
          _step(_currentState, this._attachment, offset);
        }
      }
    }

    /**
     * Configure and start a tween.
     * @method shifty.Tweenable#tween
     * @param {shifty.tweenConfig} [config] Gets passed to {@link
     * shifty.Tweenable#setConfig}
     * @return {external:Promise}
     */

  }, {
    key: 'tween',
    value: function tween() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var _attachment = this._attachment,
          _configured = this._configured,
          _isTweening = this._isTweening;


      if (_isTweening) {
        return this;
      }

      // Only set default config if no configuration has been set previously and
      // none is provided now.
      if (config !== undefined || !_configured) {
        this.setConfig(config);
      }

      this._timestamp = Tweenable.now();
      this._start(this.get(), _attachment);
      return this.resume();
    }

    /**
     * Configure a tween that will start at some point in the future.
     * @method shifty.Tweenable#setConfig
     * @param {shifty.tweenConfig} [config={}]
     * @return {shifty.Tweenable}
     */

  }, {
    key: 'setConfig',
    value: function setConfig() {
      var _this3 = this;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._configured = true;

      // Attach something to this Tweenable instance (e.g.: a DOM element, an
      // object, a string, etc.);
      this._attachment = config.attachment;

      // Init the internal state
      (0, _objectAssign2.default)(this, {
        _pausedAtTime: null,
        _scheduleId: null,
        _delay: config.delay || 0,
        _start: config.start || noop,
        _step: config.step || noop,
        _duration: config.duration || DEFAULT_DURATION,
        _currentState: clone(config.from || this.get())
      });

      // Separate Object.assign here; it depends on _currentState being set above
      (0, _objectAssign2.default)(this, {
        _originalState: this.get(),
        _targetState: clone(config.to || this.get())
      });

      var currentState = this._currentState;
      // Ensure that there is always something to tween to.
      this._targetState = (0, _objectAssign2.default)({}, currentState, this._targetState);

      this._easing = composeEasingObject(currentState, config.easing);
      this._filterArgs = [currentState, this._originalState, this._targetState, this._easing];
      this._applyFilter('tweenCreated');

      var Promised = config.promise || Promise;
      this._promise = new Promised(function (resolve, reject) {
        _this3._resolve = resolve;
        _this3._reject = reject;
      });

      // Needed to silence (harmless) logged errors when a .catch handler is not
      // added by downsteam code
      this._promise.catch(noop);

      return this;
    }

    /**
     * @method shifty.Tweenable#get
     * @return {Object} The current state.
     */

  }, {
    key: 'get',
    value: function get() {
      return clone(this._currentState);
    }

    /**
     * Set the current state.
     * @method shifty.Tweenable#set
     * @param {Object} state The state to set.
     */

  }, {
    key: 'set',
    value: function set(state) {
      this._currentState = state;
    }

    /**
     * Pause a tween.  Paused tweens can be resumed from the point at which they
     * were paused.  This is different from {@link shifty.Tweenable#stop}, as
     * that method causes a tween to start over when it is resumed.
     * @method shifty.Tweenable#pause
     * @return {shifty.Tweenable}
     */

  }, {
    key: 'pause',
    value: function pause() {
      this._pausedAtTime = Tweenable.now();
      this._isPaused = true;

      return this;
    }

    /**
     * Resume a paused tween.
     * @method shifty.Tweenable#resume
     * @return {external:Promise}
     */

  }, {
    key: 'resume',
    value: function resume() {
      if (this._isPaused) {
        this._timestamp += Tweenable.now() - this._pausedAtTime;
      }

      this._isPaused = false;
      this._isTweening = true;
      this._timeoutHandler();

      return this._promise;
    }

    /**
     * Move the state of the animation to a specific point in the tween's
     * timeline.  If the animation is not running, this will cause {@link
     * shifty.stepFunction} handlers to be called.
     * @method shifty.Tweenable#seek
     * @param {millisecond} millisecond The millisecond of the animation to seek
     * to.  This must not be less than `0`.
     * @return {shifty.Tweenable}
     */

  }, {
    key: 'seek',
    value: function seek(millisecond) {
      millisecond = Math.max(millisecond, 0);
      var currentTime = Tweenable.now();

      if (this._timestamp + millisecond === 0) {
        return this;
      }

      this._timestamp = currentTime - millisecond;

      if (!this.isPlaying()) {
        this._isTweening = true;
        this._isPaused = false;

        // If the animation is not running, call _timeoutHandler to make sure that
        // any step handlers are run.
        this._timeoutHandler(currentTime);

        this.pause();
      }

      return this;
    }

    /**
     * Stops and cancels a tween.
     * @param {boolean} [gotoEnd] If `false`, the tween just stops at its current
     * state, and the tween promise is not resolved.  If `true`, the tweened
     * object's values are instantly set to the target values, and the promise is
     * resolved.
     * @method shifty.Tweenable#stop
     * @return {shifty.Tweenable}
     */

  }, {
    key: 'stop',
    value: function stop() {
      var gotoEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _attachment = this._attachment,
          _currentState = this._currentState,
          _easing = this._easing,
          _originalState = this._originalState,
          _targetState = this._targetState;


      this._isTweening = false;
      this._isPaused = false;

      cancelTimer(this._scheduleId);

      if (gotoEnd) {
        this._applyFilter('beforeTween');
        tweenProps(1, _currentState, _originalState, _targetState, 1, 0, _easing);
        this._applyFilter('afterTween');
        this._applyFilter('afterTweenEnd');
        this._resolve(_currentState, _attachment);
      } else {
        this._reject(_currentState, _attachment);
      }

      return this;
    }

    /**
     * Whether or not a tween is running.
     * @method shifty.Tweenable#isPlaying
     * @return {boolean}
     */

  }, {
    key: 'isPlaying',
    value: function isPlaying() {
      return this._isTweening && !this._isPaused;
    }

    /**
     * Set a custom schedule function.
     *
     * By default,
     * [`requestAnimationFrame`](https://developer.mozilla.org/en-US/docs/Web/API/window.requestAnimationFrame)
     * is used if available, otherwise
     * [`setTimeout`](https://developer.mozilla.org/en-US/docs/Web/API/Window.setTimeout)
     * is used.
     * @method shifty.Tweenable#setScheduleFunction
     * @param {Function(Function,number)} scheduleFunction The function to be
     * used to schedule the next frame to be rendered.
     */

  }, {
    key: 'setScheduleFunction',
    value: function setScheduleFunction(scheduleFunction) {
      this._scheduleFunction = scheduleFunction;
    }

    /**
     * `delete` all "own" properties.  Call this when the {@link
     * shifty.Tweenable} instance is no longer needed to free memory.
     * @method shifty.Tweenable#dispose
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      var _this4 = this;

      each(this, function (prop) {
        return delete _this4[prop];
      });
    }
  }]);

  return Tweenable;
}();

(0, _objectAssign2.default)(Tweenable, {
  formulas: formulas,

  /**
   * The {@link shifty.filter}s available for use.  These filters are
   * automatically applied at tween-time by Shifty.
   * @member shifty.Tweenable.filters
   * @type {Object.<shifty.filter>}
   */
  filters: { token: token },

  /**
   * @method shifty.Tweenable.now
   * @static
   * @returns {number} The current timestamp
   */
  now: Date.now || function (_) {
    return +new Date();
  }
});

/**
 * @method shifty.tween
 * @param {shifty.tweenConfig} [config={}]
 * @description Standalone convenience method that functions identically to
 * {@link shifty.Tweenable#tween}.  You can use this to create tweens without
 * needing to set up a {@link shifty.Tweenable} instance.
 *
 *     import { tween } from 'shifty';
 *
 *     tween({ from: { x: 0 }, to: { x: 10 } }).then(
 *       () => console.log('All done!')
 *     );
 *
 * @returns {external:Promise}
 */
function tween() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var tweenable = new Tweenable();
  var promise = tweenable.tween(config);
  promise.tweenable = tweenable;

  return promise;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsetBezierFunction = exports.setBezierFunction = undefined;

var _tweenable = __webpack_require__(0);

var _objectAssign = __webpack_require__(1);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Bezier magic in this file is adapted/copied almost wholesale from
 * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/cubic-bezier.js),
 * which was adapted from Apple code (which probably came from
 * [here](http://opensource.apple.com/source/WebCore/WebCore-955.66/platform/graphics/UnitBezier.h)).
 * Special thanks to Apple and Thomas Fuchs for much of this code.
 */

/**
 *  Copyright (c) 2006 Apple Computer, Inc. All rights reserved.
 *
 *  Redistribution and use in source and binary forms, with or without
 *  modification, are permitted provided that the following conditions are met:
 *
 *  1. Redistributions of source code must retain the above copyright notice,
 *  this list of conditions and the following disclaimer.
 *
 *  2. Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation
 *  and/or other materials provided with the distribution.
 *
 *  3. Neither the name of the copyright holder(s) nor the names of any
 *  contributors may be used to endorse or promote products derived from
 *  this software without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 *  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 *  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 *  ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
 *  LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 *  CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 *  SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 *  INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 *  CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
// port of webkit cubic bezier handling by http://www.netzgesta.de/dev/

/**
 * @private
 */
function cubicBezierAtTime(t, p1x, p1y, p2x, p2y, duration) {
  var ax = 0,
      bx = 0,
      cx = 0,
      ay = 0,
      by = 0,
      cy = 0;

  var sampleCurveX = function sampleCurveX(t) {
    return ((ax * t + bx) * t + cx) * t;
  };

  var sampleCurveY = function sampleCurveY(t) {
    return ((ay * t + by) * t + cy) * t;
  };

  var sampleCurveDerivativeX = function sampleCurveDerivativeX(t) {
    return (3 * ax * t + 2 * bx) * t + cx;
  };

  var solveEpsilon = function solveEpsilon(duration) {
    return 1 / (200 * duration);
  };

  var fabs = function fabs(n) {
    return n >= 0 ? n : 0 - n;
  };

  var solveCurveX = function solveCurveX(x, epsilon) {
    var t0 = void 0,
        t1 = void 0,
        t2 = void 0,
        x2 = void 0,
        d2 = void 0,
        i = void 0;

    for (t2 = x, i = 0; i < 8; i++) {
      x2 = sampleCurveX(t2) - x;

      if (fabs(x2) < epsilon) {
        return t2;
      }

      d2 = sampleCurveDerivativeX(t2);

      if (fabs(d2) < 1e-6) {
        break;
      }

      t2 = t2 - x2 / d2;
    }

    t0 = 0;
    t1 = 1;
    t2 = x;

    if (t2 < t0) {
      return t0;
    }

    if (t2 > t1) {
      return t1;
    }

    while (t0 < t1) {
      x2 = sampleCurveX(t2);

      if (fabs(x2 - x) < epsilon) {
        return t2;
      }

      if (x > x2) {
        t0 = t2;
      } else {
        t1 = t2;
      }

      t2 = (t1 - t0) * 0.5 + t0;
    }

    return t2; // Failure.
  };

  var solve = function solve(x, epsilon) {
    return sampleCurveY(solveCurveX(x, epsilon));
  };

  cx = 3 * p1x;
  bx = 3 * (p2x - p1x) - cx;
  ax = 1 - cx - bx;
  cy = 3 * p1y;
  by = 3 * (p2y - p1y) - cy;
  ay = 1 - cy - by;

  return solve(t, solveEpsilon(duration));
}
// End ported code

/**
 *  getCubicBezierTransition(x1, y1, x2, y2) -> Function
 *
 *  Generates a transition easing function that is compatible
 *  with WebKit's CSS transitions `-webkit-transition-timing-function`
 *  CSS property.
 *
 *  The W3C has more information about CSS3 transition timing functions:
 *  http://www.w3.org/TR/css3-transitions/#transition-timing-function_tag
 *
 *  @param {number} x1
 *  @param {number} y1
 *  @param {number} x2
 *  @param {number} y2
 *  @return {function}
 *  @private
 */
var getCubicBezierTransition = function getCubicBezierTransition(x1, y1, x2, y2) {
  return function (pos) {
    return cubicBezierAtTime(pos, x1, y1, x2, y2, 1);
  };
};

/**
 * Create a Bezier easing function and attach it to {@link
 * shifty.Tweenable.formulas}.  This function gives you total control over the
 * easing curve.  Matthew Lein's [Ceaser](http://matthewlein.com/ceaser/) is a
 * useful tool for visualizing the curves you can make with this function.
 * @method shifty.setBezierFunction
 * @param {string} name The name of the easing curve.  Overwrites the old
 * easing function on {@link shifty.Tweenable.formulas} if it exists.
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @return {shifty.easingFunction} The {@link shifty.easingFunction} that was
 * attached to {@link shifty.Tweenable.formulas}.
 */
var setBezierFunction = exports.setBezierFunction = function setBezierFunction(name, x1, y1, x2, y2) {
  return _tweenable.Tweenable.formulas[name] = (0, _objectAssign2.default)(getCubicBezierTransition(x1, y1, x2, y2), {
    displayName: name,
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  });
};

/**
 * `delete` an easing function from {@link shifty.Tweenable.formulas}.  Be
 * careful with this method, as it `delete`s whatever easing formula matches
 * `name` (which means you can delete standard Shifty easing functions).
 * @method shifty.unsetBezierFunction
 * @param {string} name The name of the easing function to delete.
 * @return {Boolean} Whether or not the functions was `delete`d.
 */
var unsetBezierFunction = exports.unsetBezierFunction = function unsetBezierFunction(name) {
  return delete _tweenable.Tweenable.formulas[name];
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpolate = undefined;

var _tweenable = __webpack_require__(0);

// Fake a Tweenable and patch some internals.  This approach allows us to
// skip uneccessary processing and object recreation, cutting down on garbage
// collection pauses.
var mockTweenable = new _tweenable.Tweenable();
mockTweenable._filterArgs = [];

/**
 * Compute the midpoint of two Objects.  This method effectively calculates a
 * specific frame of animation that {@link shifty.Tweenable#tween} does many times
 * over the course of a full tween.
 *
 *     import { interpolate } from 'shifty';
 *
 *     const interpolatedValues = interpolate({
 *         width: '100px',
 *         opacity: 0,
 *         color: '#fff'
 *       }, {
 *         width: '200px',
 *         opacity: 1,
 *         color: '#000'
 *       },
 *       0.5
 *     );
 *
 *     console.log(interpolatedValues);
 *     // {opacity: 0.5, width: "150px", color: "rgb(127,127,127)"}
 *
 * @method shifty.interpolate
 * @param {Object} from The starting values to tween from.
 * @param {Object} to The ending values to tween to.
 * @param {number} position The normalized position value (between `0.0` and
 * `1.0`) to interpolate the values between `from` and `to` for.  `from`
 * represents `0` and `to` represents `1`.
 * @param {Object.<string|shifty.easingFunction>|string|shifty.easingFunction}
 * easing The easing curve(s) to calculate the midpoint against.  You can
 * reference any easing function attached to {@link shifty.Tweenable.formulas},
 * or provide the {@link shifty.easingFunction}(s) directly.  If omitted, this
 * defaults to "linear".
 * @param {number} [delay=0] Optional delay to pad the beginning of the
 * interpolated tween with.  This increases the range of `position` from (`0`
 * through `1`) to (`0` through `1 + delay`).  So, a delay of `0.5` would
 * increase all valid values of `position` to numbers between `0` and `1.5`.
 * @return {Object}
 */
var interpolate = exports.interpolate = function interpolate(from, to, position, easing) {
  var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


  var current = (0, _tweenable.clone)(from);
  var easingObject = (0, _tweenable.composeEasingObject)(from, easing);

  mockTweenable.set({});
  mockTweenable._filterArgs = [current, from, to, easingObject];

  // Any defined value transformation must be applied
  mockTweenable._applyFilter('tweenCreated');
  mockTweenable._applyFilter('beforeTween');

  var interpolatedValues = (0, _tweenable.tweenProps)(position, current, from, to, 1, delay, easingObject);

  // Transform data in interpolatedValues back into its original format
  mockTweenable._applyFilter('afterTween');

  return interpolatedValues;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*!
 * All equations are adapted from Thomas Fuchs'
 * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/penner.js).
 *
 * Based on Easing Equations (c) 2003 [Robert
 * Penner](http://www.robertpenner.com/), all rights reserved. This work is
 * [subject to terms](http://www.robertpenner.com/easing_terms_of_use.html).
 */

/*!
 *  TERMS OF USE - EASING EQUATIONS
 *  Open source under the BSD License.
 *  Easing Equations (c) 2003 Robert Penner, all rights reserved.
 */

/**
 * @member shifty.Tweenable.formulas
 * @description A static Object of {@link shifty.easingFunction}s that can by
 * used by Shifty. The default values are defined in
 * [`easing-functions.js`](easing-functions.js.html), but you can add your own
 * {@link shifty.easingFunction}s by defining them as keys to this Object.
 *
 * Shifty ships with an implementation of [Robert Penner's easing
 * equations](http://robertpenner.com/easing/), as adapted from
 * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/penner.js)'s
 * implementation.
 * <p data-height="934" data-theme-id="0" data-slug-hash="wqObdO"
 * data-default-tab="js,result" data-user="jeremyckahn" data-embed-version="2"
 * data-pen-title="Shifty - Easing formula names" class="codepen">See the Pen <a
 * href="https://codepen.io/jeremyckahn/pen/wqObdO/">Shifty - Easing formula
 * names</a> by Jeremy Kahn (<a
 * href="https://codepen.io/jeremyckahn">@jeremyckahn</a>) on <a
 * href="https://codepen.io">CodePen</a>.</p>
 * <script async
 * src="https://production-assets.codepen.io/assets/embed/ei.js"></script>
 * @type {Object.<shifty.easingFunction>}
 * @static
 */
var linear = exports.linear = function linear(pos) {
  return pos;
};

var easeInQuad = exports.easeInQuad = function easeInQuad(pos) {
  return Math.pow(pos, 2);
};

var easeOutQuad = exports.easeOutQuad = function easeOutQuad(pos) {
  return -(Math.pow(pos - 1, 2) - 1);
};

var easeInOutQuad = exports.easeInOutQuad = function easeInOutQuad(pos) {
  return (pos /= 0.5) < 1 ? 0.5 * Math.pow(pos, 2) : -0.5 * ((pos -= 2) * pos - 2);
};

var easeInCubic = exports.easeInCubic = function easeInCubic(pos) {
  return Math.pow(pos, 3);
};

var easeOutCubic = exports.easeOutCubic = function easeOutCubic(pos) {
  return Math.pow(pos - 1, 3) + 1;
};

var easeInOutCubic = exports.easeInOutCubic = function easeInOutCubic(pos) {
  return (pos /= 0.5) < 1 ? 0.5 * Math.pow(pos, 3) : 0.5 * (Math.pow(pos - 2, 3) + 2);
};

var easeInQuart = exports.easeInQuart = function easeInQuart(pos) {
  return Math.pow(pos, 4);
};

var easeOutQuart = exports.easeOutQuart = function easeOutQuart(pos) {
  return -(Math.pow(pos - 1, 4) - 1);
};

var easeInOutQuart = exports.easeInOutQuart = function easeInOutQuart(pos) {
  return (pos /= 0.5) < 1 ? 0.5 * Math.pow(pos, 4) : -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
};

var easeInQuint = exports.easeInQuint = function easeInQuint(pos) {
  return Math.pow(pos, 5);
};

var easeOutQuint = exports.easeOutQuint = function easeOutQuint(pos) {
  return Math.pow(pos - 1, 5) + 1;
};

var easeInOutQuint = exports.easeInOutQuint = function easeInOutQuint(pos) {
  return (pos /= 0.5) < 1 ? 0.5 * Math.pow(pos, 5) : 0.5 * (Math.pow(pos - 2, 5) + 2);
};

var easeInSine = exports.easeInSine = function easeInSine(pos) {
  return -Math.cos(pos * (Math.PI / 2)) + 1;
};

var easeOutSine = exports.easeOutSine = function easeOutSine(pos) {
  return Math.sin(pos * (Math.PI / 2));
};

var easeInOutSine = exports.easeInOutSine = function easeInOutSine(pos) {
  return -0.5 * (Math.cos(Math.PI * pos) - 1);
};

var easeInExpo = exports.easeInExpo = function easeInExpo(pos) {
  return pos === 0 ? 0 : Math.pow(2, 10 * (pos - 1));
};

var easeOutExpo = exports.easeOutExpo = function easeOutExpo(pos) {
  return pos === 1 ? 1 : -Math.pow(2, -10 * pos) + 1;
};

var easeInOutExpo = exports.easeInOutExpo = function easeInOutExpo(pos) {
  if (pos === 0) {
    return 0;
  }

  if (pos === 1) {
    return 1;
  }

  if ((pos /= 0.5) < 1) {
    return 0.5 * Math.pow(2, 10 * (pos - 1));
  }

  return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
};

var easeInCirc = exports.easeInCirc = function easeInCirc(pos) {
  return -(Math.sqrt(1 - pos * pos) - 1);
};

var easeOutCirc = exports.easeOutCirc = function easeOutCirc(pos) {
  return Math.sqrt(1 - Math.pow(pos - 1, 2));
};

var easeInOutCirc = exports.easeInOutCirc = function easeInOutCirc(pos) {
  return (pos /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - pos * pos) - 1) : 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
};

var easeOutBounce = exports.easeOutBounce = function easeOutBounce(pos) {
  if (pos < 1 / 2.75) {
    return 7.5625 * pos * pos;
  } else if (pos < 2 / 2.75) {
    return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
  } else if (pos < 2.5 / 2.75) {
    return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
  } else {
    return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
  }
};

var easeInBack = exports.easeInBack = function easeInBack(pos) {
  var s = 1.70158;
  return pos * pos * ((s + 1) * pos - s);
};

var easeOutBack = exports.easeOutBack = function easeOutBack(pos) {
  var s = 1.70158;
  return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
};

var easeInOutBack = exports.easeInOutBack = function easeInOutBack(pos) {
  var s = 1.70158;
  if ((pos /= 0.5) < 1) {
    return 0.5 * (pos * pos * (((s *= 1.525) + 1) * pos - s));
  }
  return 0.5 * ((pos -= 2) * pos * (((s *= 1.525) + 1) * pos + s) + 2);
};

var elastic = exports.elastic = function elastic(pos) {
  return -1 * Math.pow(4, -8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
};

var swingFromTo = exports.swingFromTo = function swingFromTo(pos) {
  var s = 1.70158;
  return (pos /= 0.5) < 1 ? 0.5 * (pos * pos * (((s *= 1.525) + 1) * pos - s)) : 0.5 * ((pos -= 2) * pos * (((s *= 1.525) + 1) * pos + s) + 2);
};

var swingFrom = exports.swingFrom = function swingFrom(pos) {
  var s = 1.70158;
  return pos * pos * ((s + 1) * pos - s);
};

var swingTo = exports.swingTo = function swingTo(pos) {
  var s = 1.70158;
  return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
};

var bounce = exports.bounce = function bounce(pos) {
  if (pos < 1 / 2.75) {
    return 7.5625 * pos * pos;
  } else if (pos < 2 / 2.75) {
    return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
  } else if (pos < 2.5 / 2.75) {
    return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
  } else {
    return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
  }
};

var bouncePast = exports.bouncePast = function bouncePast(pos) {
  if (pos < 1 / 2.75) {
    return 7.5625 * pos * pos;
  } else if (pos < 2 / 2.75) {
    return 2 - (7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75);
  } else if (pos < 2.5 / 2.75) {
    return 2 - (7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375);
  } else {
    return 2 - (7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375);
  }
};

var easeFromTo = exports.easeFromTo = function easeFromTo(pos) {
  return (pos /= 0.5) < 1 ? 0.5 * Math.pow(pos, 4) : -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
};

var easeFrom = exports.easeFrom = function easeFrom(pos) {
  return Math.pow(pos, 4);
};

var easeTo = exports.easeTo = function easeTo(pos) {
  return Math.pow(pos, 0.25);
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tweenable = __webpack_require__(0);

Object.defineProperty(exports, 'Tweenable', {
  enumerable: true,
  get: function get() {
    return _tweenable.Tweenable;
  }
});
Object.defineProperty(exports, 'tween', {
  enumerable: true,
  get: function get() {
    return _tweenable.tween;
  }
});

var _interpolate = __webpack_require__(3);

Object.defineProperty(exports, 'interpolate', {
  enumerable: true,
  get: function get() {
    return _interpolate.interpolate;
  }
});

var _bezier = __webpack_require__(2);

Object.defineProperty(exports, 'setBezierFunction', {
  enumerable: true,
  get: function get() {
    return _bezier.setBezierFunction;
  }
});
Object.defineProperty(exports, 'unsetBezierFunction', {
  enumerable: true,
  get: function get() {
    return _bezier.unsetBezierFunction;
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tweenCreated = tweenCreated;
exports.beforeTween = beforeTween;
exports.afterTween = afterTween;

var _tweenable = __webpack_require__(0);

var R_NUMBER_COMPONENT = /(\d|\-|\.)/;
var R_FORMAT_CHUNKS = /([^\-0-9\.]+)/g;
var R_UNFORMATTED_VALUES = /[0-9.\-]+/g;
var R_RGB = function () {
  var number = R_UNFORMATTED_VALUES.source;
  var comma = /,\s*/.source;

  return new RegExp('rgb\\(' + number + comma + number + comma + number + '\\)', 'g');
}();
var R_RGB_PREFIX = /^.*\(/;
var R_HEX = /#([0-9]|[a-f]){3,6}/gi;
var VALUE_PLACEHOLDER = 'VAL';

// HELPERS

/**
 * @param {Array.number} rawValues
 * @param {string} prefix
 *
 * @return {Array.<string>}
 * @private
 */
var getFormatChunksFrom = function getFormatChunksFrom(rawValues, prefix) {
  return rawValues.map(function (val, i) {
    return '_' + prefix + '_' + i;
  });
};

/**
 * @param {string} formattedString
 *
 * @return {string}
 * @private
 */
var getFormatStringFrom = function getFormatStringFrom(formattedString) {
  var chunks = formattedString.match(R_FORMAT_CHUNKS);

  if (!chunks) {
    // chunks will be null if there were no tokens to parse in
    // formattedString (for example, if formattedString is '2').  Coerce
    // chunks to be useful here.
    chunks = ['', ''];

    // If there is only one chunk, assume that the string is a number
    // followed by a token...
    // NOTE: This may be an unwise assumption.
  } else if (chunks.length === 1 ||
  // ...or if the string starts with a number component (".", "-", or a
  // digit)...
  formattedString.charAt(0).match(R_NUMBER_COMPONENT)) {

    // ...prepend an empty string here to make sure that the formatted number
    // is properly replaced by VALUE_PLACEHOLDER
    chunks.unshift('');
  }

  return chunks.join(VALUE_PLACEHOLDER);
};

/**
 * Convert a base-16 number to base-10.
 *
 * @param {Number|String} hex The value to convert
 *
 * @returns {Number} The base-10 equivalent of `hex`.
 * @private
 */
function hexToDec(hex) {
  return parseInt(hex, 16);
}

/**
 * Convert a hexadecimal string to an array with three items, one each for
 * the red, blue, and green decimal values.
 *
 * @param {string} hex A hexadecimal string.
 *
 * @returns {Array.<number>} The converted Array of RGB values if `hex` is a
 * valid string, or an Array of three 0's.
 * @private
 */
var hexToRGBArray = function hexToRGBArray(hex) {
  hex = hex.replace(/#/, '');

  // If the string is a shorthand three digit hex notation, normalize it to
  // the standard six digit notation
  if (hex.length === 3) {
    hex = hex.split('');
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  return [hexToDec(hex.substr(0, 2)), hexToDec(hex.substr(2, 2)), hexToDec(hex.substr(4, 2))];
};

/**
 * @param {string} hexString
 *
 * @return {string}
 * @private
 */
var convertHexToRGB = function convertHexToRGB(hexString) {
  return 'rgb(' + hexToRGBArray(hexString).join(',') + ')';
};

/**
 * TODO: Can this be rewritten to leverage String#replace more efficiently?
 * Runs a filter operation on all chunks of a string that match a RegExp
 *
 * @param {RegExp} pattern
 * @param {string} unfilteredString
 * @param {function(string)} filter
 *
 * @return {string}
 * @private
 */
var filterStringChunks = function filterStringChunks(pattern, unfilteredString, filter) {
  var patternMatches = unfilteredString.match(pattern);
  var filteredString = unfilteredString.replace(pattern, VALUE_PLACEHOLDER);

  if (patternMatches) {
    patternMatches.forEach(function (match) {
      return filteredString = filteredString.replace(VALUE_PLACEHOLDER, filter(match));
    });
  }

  return filteredString;
};

/**
 * @param {string} str
 *
 * @return {string}
 * @private
 */
var sanitizeHexChunksToRGB = function sanitizeHexChunksToRGB(str) {
  return filterStringChunks(R_HEX, str, convertHexToRGB);
};

/**
 * Convert all hex color values within a string to an rgb string.
 *
 * @param {Object} stateObject
 *
 * @return {Object} The modified obj
 * @private
 */
var sanitizeObjectForHexProps = function sanitizeObjectForHexProps(stateObject) {
  (0, _tweenable.each)(stateObject, function (prop) {
    var currentProp = stateObject[prop];

    if (typeof currentProp === 'string' && currentProp.match(R_HEX)) {
      stateObject[prop] = sanitizeHexChunksToRGB(currentProp);
    }
  });
};

/**
 * @param {string} rgbChunk
 *
 * @return {string}
 * @private
 */
var sanitizeRGBChunk = function sanitizeRGBChunk(rgbChunk) {
  var numbers = rgbChunk.match(R_UNFORMATTED_VALUES).map(Math.floor);
  var prefix = rgbChunk.match(R_RGB_PREFIX)[0];

  return '' + prefix + numbers.join(',') + ')';
};

/**
 * Check for floating point values within rgb strings and round them.
 *
 * @param {string} formattedString
 *
 * @return {string}
 * @private
 */
var sanitizeRGBChunks = function sanitizeRGBChunks(formattedString) {
  return filterStringChunks(R_RGB, formattedString, sanitizeRGBChunk);
};

/**
 * Note: It's the duty of the caller to convert the Array elements of the
 * return value into numbers.  This is a performance optimization.
 *
 * @param {string} formattedString
 *
 * @return {Array.<string>|null}
 * @private
 */
var getValuesFrom = function getValuesFrom(formattedString) {
  return formattedString.match(R_UNFORMATTED_VALUES);
};

/**
 * @param {Object} stateObject
 *
 * @return {Object} An Object of formatSignatures that correspond to
 * the string properties of stateObject
 * @private
 */
var getFormatSignatures = function getFormatSignatures(stateObject) {
  var signatures = {};

  (0, _tweenable.each)(stateObject, function (propertyName) {
    var property = stateObject[propertyName];

    if (typeof property === 'string') {
      signatures[propertyName] = {
        formatString: getFormatStringFrom(property),
        chunkNames: getFormatChunksFrom(getValuesFrom(property), propertyName)
      };
    }
  });

  return signatures;
};

/**
 * @param {Object} stateObject
 * @param {Object} formatSignatures
 * @private
 */
var expandFormattedProperties = function expandFormattedProperties(stateObject, formatSignatures) {
  (0, _tweenable.each)(formatSignatures, function (propertyName) {
    getValuesFrom(stateObject[propertyName]).forEach(function (number, i) {
      return stateObject[formatSignatures[propertyName].chunkNames[i]] = +number;
    });

    delete stateObject[propertyName];
  });
};

/**
 * @param {Object} stateObject
 * @param {Array.<string>} chunkNames
 *
 * @return {Object} The extracted value chunks.
 * @private
 */
var extractPropertyChunks = function extractPropertyChunks(stateObject, chunkNames) {
  var extractedValues = {};

  chunkNames.forEach(function (chunkName) {
    extractedValues[chunkName] = stateObject[chunkName];
    delete stateObject[chunkName];
  });

  return extractedValues;
};

/**
 * @param {Object} stateObject
 * @param {Array.<string>} chunkNames
 *
 * @return {Array.<number>}
 * @private
 */
var getValuesList = function getValuesList(stateObject, chunkNames) {
  return chunkNames.map(function (chunkName) {
    return stateObject[chunkName];
  });
};

/**
 * @param {string} formatString
 * @param {Array.<number>} rawValues
 *
 * @return {string}
 * @private
 */
var getFormattedValues = function getFormattedValues(formatString, rawValues) {
  rawValues.forEach(function (rawValue) {
    return formatString = formatString.replace(VALUE_PLACEHOLDER, +rawValue.toFixed(4));
  });

  return formatString;
};

/**
 * @param {Object} stateObject
 * @param {Object} formatSignatures
 * @private
 */
var collapseFormattedProperties = function collapseFormattedProperties(stateObject, formatSignatures) {
  (0, _tweenable.each)(formatSignatures, function (prop) {
    var _formatSignatures$pro = formatSignatures[prop],
        chunkNames = _formatSignatures$pro.chunkNames,
        formatString = _formatSignatures$pro.formatString;


    var currentProp = getFormattedValues(formatString, getValuesList(extractPropertyChunks(stateObject, chunkNames), chunkNames));

    stateObject[prop] = sanitizeRGBChunks(currentProp);
  });
};

/**
 * @param {Object} easingObject
 * @param {Object} tokenData
 * @private
 */
var expandEasingObject = function expandEasingObject(easingObject, tokenData) {
  (0, _tweenable.each)(tokenData, function (prop) {
    var chunkNames = tokenData[prop].chunkNames;

    var easing = easingObject[prop];

    if (typeof easing === 'string') {
      (function () {
        var easingNames = easing.split(' ');
        var defaultEasing = easingNames[easingNames.length - 1];

        chunkNames.forEach(function (chunkName, i) {
          return easingObject[chunkName] = easingNames[i] || defaultEasing;
        });
      })();
    } else {
      // easing is a function
      chunkNames.forEach(function (chunkName) {
        return easingObject[chunkName] = easing;
      });
    }

    delete easingObject[prop];
  });
};

/**
 * @param {Object} easingObject
 * @param {Object} tokenData
 * @private
 */
var collapseEasingObject = function collapseEasingObject(easingObject, tokenData) {
  (0, _tweenable.each)(tokenData, function (prop) {
    var chunkNames = tokenData[prop].chunkNames;
    var length = chunkNames.length;

    var firstEasing = easingObject[chunkNames[0]];

    if (typeof firstEasing === 'string') {
      easingObject[prop] = chunkNames.map(function (chunkName) {
        var easingName = easingObject[chunkName];
        delete easingObject[chunkName];

        return easingName;
      }).join(' ');
    } else {
      // firstEasing is a function
      easingObject[prop] = firstEasing;
    }
  });
};

function tweenCreated(currentState, fromState, toState) {
  [currentState, fromState, toState].forEach(sanitizeObjectForHexProps);

  this._tokenData = getFormatSignatures(currentState);
}

function beforeTween(currentState, fromState, toState, easingObject) {
  var _tokenData = this._tokenData;

  expandEasingObject(easingObject, _tokenData);

  [currentState, fromState, toState].forEach(function (state) {
    return expandFormattedProperties(state, _tokenData);
  });
}

function afterTween(currentState, fromState, toState, easingObject) {
  var _tokenData = this._tokenData;

  [currentState, fromState, toState].forEach(function (state) {
    return collapseFormattedProperties(state, _tokenData);
  });

  collapseEasingObject(easingObject, _tokenData);
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// shifty.js